import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetFooter,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import ReceiptIcon from '@/components/icons/receipt-icon';

interface InvoiceHistoryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  clientName: string;
}

const InvoiceHistoryModal: React.FC<InvoiceHistoryModalProps> = ({
  open,
  onOpenChange,
  clientName,
}) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange} modal={false}>
      <SheetContent className="sm:max-w-[500px] w-full overflow-y-auto" pushed={open}>
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <ReceiptIcon size={20} className="text-blue-500" />
            Invoice History: {clientName}
          </SheetTitle>
          <SheetDescription>
            View historical invoices and their payment status
          </SheetDescription>
        </SheetHeader>

        <div className="flex flex-col items-center justify-center py-12 text-center">
          <div className="rounded-full bg-slate-100 p-4 mb-4">
            <ReceiptIcon size={40} className="text-slate-400" />
          </div>
          <h3 className="text-lg font-medium mb-2">Invoice History Coming Soon</h3>
          <p className="text-sm text-slate-500 max-w-xs">
            This feature will allow you to view all historical invoices for this client, their status, and total amounts.
          </p>
        </div>

        <SheetFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export default InvoiceHistoryModal;